// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
  width: 300px;
  height: 300px;
  padding: 0px;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  background-color: transparent;
}

.image-container img {
  position: absolute;
  top: -10%;
  left: 55%;
  transform: translateX(-50%);
  width: 100%;
  height: 210%;
  object-fit: cover;
}

.image-container svg {
  width: 100%;
  height: 100%;
  color: rgba(169, 88, 215, 1);
}
`, "",{"version":3,"sources":["webpack://./src/features/avatar/AvatarImage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":[".image-container {\n  width: 300px;\n  height: 300px;\n  padding: 0px;\n  overflow: hidden;\n  position: relative;\n  border-radius: 50%;\n  background-color: transparent;\n}\n\n.image-container img {\n  position: absolute;\n  top: -10%;\n  left: 55%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 210%;\n  object-fit: cover;\n}\n\n.image-container svg {\n  width: 100%;\n  height: 100%;\n  color: rgba(169, 88, 215, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
